import { Box } from '@mui/material';
import NameFields from 'components/payment/spreedly/spreedly-card/forms/fields/name-fields.component';
import SpreedlyCheckoutSdkCardFields from './fields/spreedly-checkout-sdk-card-fields.component';

export const SpreedlyCheckoutSdkDefault = () => {
  return (
    <Box display="grid" rowGap={theme => theme.spacing(2)}>
      <NameFields />
      <SpreedlyCheckoutSdkCardFields />
    </Box>
  );
};
